import { IChecklistDelegate } from './../checklist/checklist';
import { IChecklistItemStrategy } from './../../strategies/checklist_item_strategy';
import { Strategy } from 'utility-ts-strategy';
import { ChecklistItem } from './../../builders/checklist_item_builder';

interface IItemDetailsScope extends ng.IScope {
  item: ChecklistItem;
}

export class ItemDetailsController {
  private strategy: IChecklistItemStrategy;

  constructor(
    private $scope: IItemDetailsScope,
    private ngChecklistItemStrategy: Strategy<IChecklistItemStrategy>,
    private checklistDelegate: IChecklistDelegate
  ) {}

  $onInit() {
    if (!_.isUndefined(this.$scope.item) && !_.isUndefined(this.$scope.item.status)) {
      this.strategy = this.ngChecklistItemStrategy[this.$scope.item.status];
    } else {
      this.strategy = this.ngChecklistItemStrategy['preview'];
    }
  }

  isNormal() {
    return this.$scope.item.status === 'normal';
  }

  isComplete() {
    return this.$scope.item.status === 'complete';
  }

  isTransition() {
    return this.strategy.isUndoable(this.$scope.item);
  }

  transition($event: Event) {
    this.checklistDelegate.setTimer(this.$scope.item);
  }

  cancelTransition() {
    this.checklistDelegate.cancelTimer(this.$scope.item);
  }
}

angular
  .module('capability-ng-checklist')
  .controller('ngItemDetailsController', ItemDetailsController)
  .directive('itemDetails', () => {
    return {
      templateUrl: 'lib/checklist/components/item_details/item_details.html',
      controller: 'ngItemDetailsController',
      controllerAs: '$ctrl',
      scope: {
        item: '<'
      }
    };
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/components/item_details/item_details.ts